import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import Dialog from './Dialog';
const InfoDialog = (props) => {
    const { content, className } = props, remainingProps = __rest(props, ["content", "className"]);
    const dialogClassName = `${className ? className : ''} info-dialog`;
    return _jsx(Dialog, Object.assign({}, remainingProps, { body: content, className: dialogClassName }));
};
export default InfoDialog;
